/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SplitOrderReqSplitGoodsVo } from './SplitOrderReqSplitGoodsVo';
import {
    SplitOrderReqSplitGoodsVoFromJSON,
    SplitOrderReqSplitGoodsVoFromJSONTyped,
    SplitOrderReqSplitGoodsVoToJSON,
    SplitOrderReqSplitGoodsVoToJSONTyped,
} from './SplitOrderReqSplitGoodsVo';

/**
 * 
 * @export
 * @interface SplitOrderReqVo
 */
export interface SplitOrderReqVo {
    /**
     * 订单id
     * @type {number}
     * @memberof SplitOrderReqVo
     */
    orderId?: number;
    /**
     * 分单商品列表
     * @type {Array<SplitOrderReqSplitGoodsVo>}
     * @memberof SplitOrderReqVo
     */
    splitGoodsList?: Array<SplitOrderReqSplitGoodsVo>;
}

/**
 * Check if a given object implements the SplitOrderReqVo interface.
 */
export function instanceOfSplitOrderReqVo(value: object): value is SplitOrderReqVo {
    return true;
}

export function SplitOrderReqVoFromJSON(json: any): SplitOrderReqVo {
    return SplitOrderReqVoFromJSONTyped(json, false);
}

export function SplitOrderReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SplitOrderReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'splitGoodsList': json['splitGoodsList'] == null ? undefined : ((json['splitGoodsList'] as Array<any>).map(SplitOrderReqSplitGoodsVoFromJSON)),
    };
}

export function SplitOrderReqVoToJSON(json: any): SplitOrderReqVo {
    return SplitOrderReqVoToJSONTyped(json, false);
}

export function SplitOrderReqVoToJSONTyped(value?: SplitOrderReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'splitGoodsList': value['splitGoodsList'] == null ? undefined : ((value['splitGoodsList'] as Array<any>).map(SplitOrderReqSplitGoodsVoToJSON)),
    };
}

